export const iconRegistry = [
    {
        name: "tesla-electric",
        metadata: { aliases: ["te"] },
        variants: [{ id: "icon-tesla-electric", viewBox: "0 0 24 24" }],
    },
    {
        name: "ship-wheel",
        metadata: { aliases: ["wheel", "kubernetes", "navigate"] },
        variants: [
            { id: "icon-ship-wheel-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-ship-wheel", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "cube",
        metadata: { aliases: ["lootbox", "hexagon", "hex", "box"] },
        variants: [
            { id: "icon-cube-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-cube", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "sidebar",
        metadata: { aliases: ["side panel", "layout", "sidenav"] },
        variants: [
            {
                id: "icon-sidebar-left-filled",
                viewBox: "0 0 24 24",
                variant: "left",
                filled: true,
            },
            { id: "icon-sidebar-left", viewBox: "0 0 24 24", variant: "left" },
            {
                id: "icon-sidebar-right-filled",
                viewBox: "0 0 24 24",
                variant: "right",
                filled: true,
            },
            { id: "icon-sidebar-right", viewBox: "0 0 24 24", variant: "right" },
        ],
    },
    {
        name: "server",
        metadata: { aliases: ["database", "storage", "hosting"] },
        variants: [
            { id: "icon-server-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-server", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "fit-width",
        metadata: { aliases: ["expand", "pdf", "view"] },
        variants: [
            { id: "icon-fit-width-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-fit-width", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "fit-height",
        metadata: { aliases: ["expand", "pdf", "view"] },
        variants: [
            { id: "icon-fit-height-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-fit-height", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "ac",
        metadata: { aliases: ["ice", "cold", "acceptance criteria"] },
        variants: [
            { id: "icon-ac-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-ac", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "accessibility",
        metadata: {
            description: "person in circle",
            groups: ["starterkit"],
            aliases: ["person", "a11y"],
        },
        variants: [
            { id: "icon-accessibility-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-accessibility", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "air-front-seats",
        metadata: { groups: ["vehicle"] },
        variants: [{ id: "icon-air-front-seats", viewBox: "0 0 24 24" }],
    },
    {
        name: "air-rear-seats",
        metadata: { groups: ["vehicle"] },
        variants: [{ id: "icon-air-rear-seats", viewBox: "0 0 24 24" }],
    },
    {
        name: "airwave",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-airwave-down", viewBox: "0 0 24 24", variant: "down" },
            { id: "icon-airwave-front", viewBox: "0 0 24 24", variant: "front" },
            { id: "icon-airwave-up", viewBox: "0 0 24 24", variant: "up" },
        ],
    },
    {
        name: "arrow",
        metadata: { groups: ["starterkit"], aliases: ["pointer", "direction"] },
        variants: [
            { id: "icon-arrow-0", viewBox: "0 0 24 24", variant: "0" },
            { id: "icon-arrow-180", viewBox: "0 0 24 24", variant: "180" },
            { id: "icon-arrow-270", viewBox: "0 0 24 24", variant: "270" },
            { id: "icon-arrow-90", viewBox: "0 0 24 24", variant: "90" },
            {
                id: "icon-arrow-filled-0",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "0",
            },
            {
                id: "icon-arrow-filled-180",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "180",
            },
            {
                id: "icon-arrow-filled-270",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "270",
            },
            {
                id: "icon-arrow-filled-90",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "90",
            },
            { id: "icon-arrow-filled", viewBox: "0 0 24 24", filled: true },
            {
                id: "icon-arrow-small-0",
                viewBox: "0 0 16 16",
                small: true,
                variant: "0",
            },
            {
                id: "icon-arrow-small-180",
                viewBox: "0 0 16 16",
                small: true,
                variant: "180",
            },
            {
                id: "icon-arrow-small-270",
                viewBox: "0 0 16 16",
                small: true,
                variant: "270",
            },
            {
                id: "icon-arrow-small-90",
                viewBox: "0 0 16 16",
                small: true,
                variant: "90",
            },
            { id: "icon-arrow-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-arrow", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "attach",
        metadata: { aliases: ["add", "file", "upload", "clip", "paperclip"] },
        variants: [
            { id: "icon-attach-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-attach", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "backward",
        metadata: { aliases: ["rewind", "step", "skip"], groups: ["media"] },
        variants: [
            { id: "icon-backward-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-backward", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "bag",
        metadata: { aliases: ["shop", "shopping", "upload"] },
        variants: [
            { id: "icon-bag-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-bag", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "bank",
        metadata: { aliases: ["institution", "building", "facility"] },
        variants: [
            { id: "icon-bank-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-bank", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "battery",
        metadata: { aliases: ["charge", "charging"] },
        variants: [
            { id: "icon-battery-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-battery", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "battery-alt",
        metadata: { aliases: ["car battery"], groups: ["vehicle"] },
        variants: [
            { id: "icon-battery-alt-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-battery-alt", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "battery-disabled",
        variants: [
            {
                id: "icon-battery-disabled-filled",
                viewBox: "0 0 24 24",
                filled: true,
            },
            { id: "icon-battery-disabled", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "battery-empty",
        metadata: { aliases: ["charge", "charging"] },
        variants: [
            { id: "icon-battery-empty-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-battery-empty", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "bed",
        metadata: { aliases: ["hotel", "stay", "rest", "sleep"] },
        variants: [
            { id: "icon-bed-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-bed", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "bell",
        metadata: { groups: ["starterkit"], aliases: ["notifications"] },
        variants: [
            { id: "icon-bell-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-bell", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "biohazard",
        metadata: { aliases: ["bio", "waste"] },
        variants: [
            { id: "icon-biohazard-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-biohazard", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "blocked",
        metadata: { aliases: ["status"] },
        variants: [
            { id: "icon-blocked-filled", viewBox: "0 0 24 24", filled: true },
            {
                id: "icon-blocked-small-filled",
                viewBox: "0 0 16 16",
                small: true,
                filled: true,
            },
            { id: "icon-blocked-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-blocked", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "bluetooth",
        metadata: { aliases: ["connect"] },
        variants: [
            { id: "icon-bluetooth-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-bluetooth", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "bluetooth-alt",
        metadata: {
            description: "this should really be merged with bluetooth and become bluetooth--filled",
            aliases: ["connect"],
        },
        variants: [{ id: "icon-bluetooth-alt", viewBox: "0 0 24 24" }],
    },
    {
        name: "bolt",
        metadata: { groups: ["starterkit"], aliases: ["lightning", "power"] },
        variants: [
            { id: "icon-bolt-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-bolt", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "bookmark",
        metadata: { aliases: ["favorite", "save", "star"] },
        variants: [
            { id: "icon-bookmark-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-bookmark", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "box",
        metadata: { aliases: ["ship", "pack", "logistics", "container"] },
        variants: [
            { id: "icon-box-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-box", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "branch",
        metadata: { aliases: ["git", "code", "fork", "split"] },
        variants: [
            { id: "icon-branch-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-branch", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "brights",
        metadata: { aliases: ["lights"] },
        variants: [
            { id: "icon-brights-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-brights", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "calendar",
        metadata: { groups: ["starterkit"], aliases: ["date", "time"] },
        variants: [
            { id: "icon-calendar-add", viewBox: "0 0 24 24", variant: "add" },
            {
                id: "icon-calendar-filled-add",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "add",
            },
            { id: "icon-calendar-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-calendar", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "camera",
        metadata: { groups: ["starterkit"], aliases: ["photo"] },
        variants: [
            { id: "icon-camera-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-camera", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "camera-lens",
        metadata: {
            aliases: ["camera", "hal9000", "hal", "vision"],
            groups: ["common", "vehicle"],
        },
        variants: [{ id: "icon-camera-lens", viewBox: "0 0 24 24" }],
    },
    {
        name: "camp",
        metadata: { aliases: ["tent"], groups: ["vehicle"] },
        variants: [
            { id: "icon-camp-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-camp", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "caps",
        metadata: { aliases: ["caps lock"] },
        variants: [
            { id: "icon-caps-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-caps", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "car-settings",
        metadata: {
            groups: ["vehicle"],
            aliases: ["settings", "configure", "menu"],
        },
        variants: [
            { id: "icon-car-settings-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-car-settings", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "cart",
        metadata: { groups: ["starterkit"], aliases: ["bag", "shop"] },
        variants: [
            { id: "icon-cart-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-cart", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "cc",
        metadata: {
            aliases: ["closed caption"],
            groups: ["common", "media", "starterkit"],
        },
        variants: [
            { id: "icon-cc-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-cc", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "charge",
        metadata: { aliases: ["plug", "power", "adapter"] },
        variants: [
            { id: "icon-charge-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-charge", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "chart",
        metadata: { aliases: ["graph", "data"] },
        variants: [
            { id: "icon-chart-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-chart", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "chart-alt",
        metadata: { aliases: ["graph", "data"] },
        variants: [
            { id: "icon-chart-alt-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-chart-alt", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "check",
        metadata: { groups: ["starterkit"], aliases: ["mark", "confirm"] },
        variants: [
            { id: "icon-check-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-check-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-check", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "chevron",
        metadata: {
            groups: ["starterkit"],
            aliases: ["arrow", "pointer", "direction"],
        },
        variants: [
            { id: "icon-chevron-0", viewBox: "0 0 24 24", variant: "0" },
            { id: "icon-chevron-180", viewBox: "0 0 24 24", variant: "180" },
            { id: "icon-chevron-270", viewBox: "0 0 24 24", variant: "270" },
            { id: "icon-chevron-90", viewBox: "0 0 24 24", variant: "90" },
            {
                id: "icon-chevron-filled-0",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "0",
            },
            {
                id: "icon-chevron-filled-180",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "180",
            },
            {
                id: "icon-chevron-filled-270",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "270",
            },
            {
                id: "icon-chevron-filled-90",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "90",
            },
            { id: "icon-chevron-filled", viewBox: "0 0 24 24", filled: true },
            {
                id: "icon-chevron-small-0",
                viewBox: "0 0 16 16",
                small: true,
                variant: "0",
            },
            {
                id: "icon-chevron-small-180",
                viewBox: "0 0 16 16",
                small: true,
                variant: "180",
            },
            {
                id: "icon-chevron-small-270",
                viewBox: "0 0 16 16",
                small: true,
                variant: "270",
            },
            {
                id: "icon-chevron-small-90",
                viewBox: "0 0 16 16",
                small: true,
                variant: "90",
            },
            { id: "icon-chevron-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-chevron", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "child-lock",
        metadata: { aliases: ["safety"] },
        variants: [
            { id: "icon-child-lock-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-child-lock", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "clock",
        metadata: { aliases: ["date", "time"] },
        variants: [
            { id: "icon-clock-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-clock", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "close",
        metadata: { aliases: ["x", "cancel", "stop"], groups: ["starterkit"] },
        variants: [
            { id: "icon-close-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-close-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-close", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "code",
        metadata: {
            aliases: [
                "html",
                "brackets",
                "markup",
                "html",
                "react",
                "dev",
                "matrix",
                "source",
            ],
        },
        variants: [
            { id: "icon-code-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-code", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "coffee",
        metadata: { aliases: ["drink", "beverage", "power", "energy"] },
        variants: [
            { id: "icon-coffee-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-coffee", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "collision",
        metadata: {
            aliases: ["collision & glass", "collision center", "body shop"],
        },
        variants: [
            { id: "icon-collision-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-collision", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "columns",
        metadata: {
            aliases: ["collection", "sort", "options", "row", "table", "column"],
            groups: ["common", "starterkit"],
        },
        variants: [
            { id: "icon-columns-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-columns", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "commit",
        metadata: { aliases: ["git", "code"] },
        variants: [
            { id: "icon-commit-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-commit", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "company",
        metadata: { aliases: ["building", "office", "skyscraper", "corporate"] },
        variants: [
            { id: "icon-company-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-company", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "computer",
        metadata: { aliases: ["monitor", "desktop", "pc", "mac"] },
        variants: [
            { id: "icon-computer-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-computer", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "connection",
        metadata: { aliases: ["signal"] },
        variants: [
            { id: "icon-connection-1", viewBox: "0 0 24 24", variant: "1" },
            { id: "icon-connection-2", viewBox: "0 0 24 24", variant: "2" },
            { id: "icon-connection-3", viewBox: "0 0 24 24", variant: "3" },
            { id: "icon-connection-4", viewBox: "0 0 24 24", variant: "4" },
            {
                id: "icon-connection-disabled",
                viewBox: "0 0 24 24",
                variant: "disabled",
            },
            {
                id: "icon-connection-filled-1",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "1",
            },
            {
                id: "icon-connection-filled-2",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "2",
            },
            {
                id: "icon-connection-filled-3",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "3",
            },
            {
                id: "icon-connection-filled-4",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "4",
            },
            {
                id: "icon-connection-filled-disabled",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "disabled",
            },
            {
                id: "icon-connection-filled-lte",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "lte",
            },
            { id: "icon-connection-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-connection-lte", viewBox: "0 0 24 24", variant: "lte" },
            { id: "icon-connection", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "contact",
        metadata: { groups: ["starterkit"], aliases: ["roster"] },
        variants: [
            { id: "icon-contact-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-contact", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "content",
        metadata: { aliases: ["document"] },
        variants: [
            { id: "icon-content-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-content", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "contract",
        metadata: { aliases: ["document"] },
        variants: [
            { id: "icon-contract-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-contract", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "controls",
        metadata: { aliases: ["toggle", "switch"] },
        variants: [
            { id: "icon-controls-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-controls", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "copy",
        metadata: { aliases: ["duplicate"], groups: ["starterkit"] },
        variants: [
            { id: "icon-copy-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-copy", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "crosshair",
        metadata: { aliases: ["mark", "target"], groups: ["starterkit"] },
        variants: [
            { id: "icon-crosshair-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-crosshair", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "currency",
        metadata: { aliases: ["dollar"] },
        variants: [
            { id: "icon-currency-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-currency", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "dashcam",
        metadata: { groups: ["vehicle"] },
        variants: [
            {
                id: "icon-dashcam-download",
                viewBox: "0 0 24 24",
                variant: "download",
            },
            { id: "icon-dashcam-error", viewBox: "0 0 24 24", variant: "error" },
            {
                id: "icon-dashcam-filled-download",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "download",
            },
            {
                id: "icon-dashcam-filled-error",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "error",
            },
            {
                id: "icon-dashcam-filled-pause",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "pause",
            },
            {
                id: "icon-dashcam-filled-recording",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "recording",
            },
            {
                id: "icon-dashcam-filled-success",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "success",
            },
            { id: "icon-dashcam-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-dashcam-pause", viewBox: "0 0 24 24", variant: "pause" },
            {
                id: "icon-dashcam-recording",
                viewBox: "0 0 24 24",
                variant: "recording",
            },
            { id: "icon-dashcam-success", viewBox: "0 0 24 24", variant: "success" },
            { id: "icon-dashcam", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "defrost-car",
        metadata: { groups: ["vehicle"] },
        variants: [
            {
                id: "icon-defrost-car-model-s-filled",
                viewBox: "0 0 24 24",
                variant: "model-s",
                filled: true,
            },
            {
                id: "icon-defrost-car-semi-filled",
                viewBox: "0 0 24 24",
                variant: "semi",
                filled: true,
            },
        ],
    },
    {
        name: "defrost-front",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-defrost-front-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-defrost-front", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "defrost-rear",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-defrost-rear-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-defrost-rear", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "diagnostics",
        metadata: { groups: ["common", "starterkit"], aliases: ["pulse", "test"] },
        variants: [{ id: "icon-diagnostics", viewBox: "0 0 24 24" }],
    },
    {
        name: "dialer",
        metadata: { aliases: ["apps", "dots"] },
        variants: [
            { id: "icon-dialer-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-dialer", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "dice",
        metadata: { aliases: ["odds", "chance"], groups: ["vehicle"] },
        variants: [
            { id: "icon-dice-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-dice", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "directions",
        metadata: { aliases: ["arrow", "maps", "travel"], groups: ["native"] },
        variants: [
            { id: "icon-directions-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-directions", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "disabled",
        metadata: {
            description: "diagonal line inside a circle",
            aliases: ["slash"],
        },
        variants: [
            { id: "icon-disabled-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-disabled", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "dislike",
        metadata: { aliases: ["thumbs down", "bad", "disapprove"] },
        variants: [
            { id: "icon-dislike-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-dislike", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "display",
        metadata: { aliases: ["screen"] },
        variants: [
            { id: "icon-display-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-display", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "display-lock",
        metadata: { aliases: ["screen lock"], groups: ["vehicle"] },
        variants: [
            { id: "icon-display-lock-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-display-lock", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "document",
        metadata: { aliases: ["doc", "page", "file"] },
        variants: [
            { id: "icon-document-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-document", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "dog",
        metadata: { aliases: ["paw"], groups: ["vehicle"] },
        variants: [{ id: "icon-dog", viewBox: "0 0 24 24" }],
    },
    {
        name: "dome-light",
        metadata: { aliases: ["overhead light"], groups: ["vehicle"] },
        variants: [
            { id: "icon-dome-light-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-dome-light", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "doors-open",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-doors-open-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-doors-open", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "double-chevron",
        metadata: { groups: ["starterkit"], aliases: ["arrow", "sort"] },
        variants: [
            { id: "icon-double-chevron-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-double-chevron-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-double-chevron", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "download",
        metadata: { groups: ["starterkit"], aliases: ["arrow"] },
        variants: [
            { id: "icon-download-filled", viewBox: "0 0 24 24", filled: true },
            {
                id: "icon-download-small-filled",
                viewBox: "0 0 16 16",
                small: true,
                filled: true,
            },
            { id: "icon-download-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-download", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "download-circle",
        metadata: { aliases: ["arrow"] },
        variants: [
            { id: "icon-download-circle-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-download-circle", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "drag",
        metadata: { aliases: ["touch", "bars", "drag and drop", "drag & drop"] },
        variants: [
            { id: "icon-drag-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-drag", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "drag-alt",
        metadata: { aliases: ["touch", "bars", "drag and drop", "drag & drop"] },
        variants: [
            { id: "icon-drag-alt-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-drag-alt", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "earth",
        metadata: { aliases: ["globe", "satellite"] },
        variants: [
            { id: "icon-earth-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-earth", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "elevation",
        metadata: { aliases: ["mountain"] },
        variants: [
            { id: "icon-elevation-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-elevation", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "ellipsis",
        metadata: { groups: ["starterkit"], aliases: ["overflow", "dots"] },
        variants: [
            { id: "icon-ellipsis-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-ellipsis-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-ellipsis", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "energy-grid",
        metadata: { aliases: ["grid", "power line", "powerline", "energy"] },
        variants: [
            { id: "icon-energy-grid-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-energy-grid", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "error",
        metadata: { groups: ["starterkit"], aliases: ["status", "warning"] },
        variants: [
            { id: "icon-error-filled", viewBox: "0 0 24 24", filled: true },
            {
                id: "icon-error-small-filled",
                viewBox: "0 0 16 16",
                small: true,
                filled: true,
            },
            { id: "icon-error-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-error", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "external",
        metadata: { groups: ["common", "media", "starterkit"] },
        variants: [
            { id: "icon-external-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-external", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "eye",
        metadata: { groups: ["starterkit"], aliases: ["look", "see", "sight"] },
        variants: [
            {
                id: "icon-eye-filled-off",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "off",
            },
            { id: "icon-eye-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-eye-off", viewBox: "0 0 24 24", variant: "off" },
            { id: "icon-eye", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "fan",
        metadata: { groups: ["vehicle"], aliases: ["climate"] },
        variants: [
            { id: "icon-fan-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-fan", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "fast-forward",
        metadata: { aliases: ["skip", "ff"], groups: ["media"] },
        variants: [
            { id: "icon-fast-forward-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-fast-forward", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "ferry",
        metadata: { aliases: ["boat", "ship"], groups: ["vehicle"] },
        variants: [
            { id: "icon-ferry-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-ferry", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "filter",
        metadata: { groups: ["starterkit"], aliases: ["search", "options"] },
        variants: [{ id: "icon-filter", viewBox: "0 0 24 24" }],
    },
    {
        name: "folder",
        variants: [
            { id: "icon-folder-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-folder", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "forward",
        metadata: { aliases: ["skip", "step"], groups: ["media"] },
        variants: [
            { id: "icon-forward-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-forward", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "frunk",
        metadata: { groups: ["common", "vehicle"], aliases: ["trunk"] },
        variants: [
            { id: "icon-frunk-filled", viewBox: "0 0 24 24", filled: true },
            {
                id: "icon-frunk-semi-filled",
                viewBox: "0 0 24 24",
                variant: "semi",
                filled: true,
            },
            { id: "icon-frunk-semi", viewBox: "0 0 24 24", variant: "semi" },
            { id: "icon-frunk", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "fullscreen",
        metadata: {
            groups: ["common", "media", "starterkit"],
            aliases: ["expand"],
        },
        variants: [
            { id: "icon-fullscreen-exit", viewBox: "0 0 24 24", variant: "exit" },
            {
                id: "icon-fullscreen-filled-exit",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "exit",
            },
            { id: "icon-fullscreen-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-fullscreen", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "gear",
        metadata: { groups: ["starterkit"], aliases: ["configure", "settings"] },
        variants: [
            { id: "icon-gear-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-gear", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "gift",
        metadata: { aliases: ["present", "incentive", "wrap", "holiday"] },
        variants: [{ id: "icon-gift", viewBox: "0 0 24 24" }],
    },
    {
        name: "globe",
        metadata: {
            groups: ["common", "starterkit"],
            aliases: [
                "localization",
                "l10n",
                "internationalization",
                "i18n",
                "planet",
                "global",
            ],
        },
        variants: [
            { id: "icon-globe-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-globe", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "glovebox",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-glovebox-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-glovebox", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "grid",
        metadata: { aliases: ["list", "layout"] },
        variants: [
            { id: "icon-grid-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-grid", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "hd",
        metadata: { aliases: ["high definition"], groups: ["vehicle"] },
        variants: [
            { id: "icon-hd-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-hd", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "heat",
        metadata: { aliases: ["warm"], groups: ["vehicle"] },
        variants: [
            { id: "icon-heat-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-heat", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "heat-wheel",
        metadata: { groups: ["vehicle"] },
        variants: [{ id: "icon-heat-wheel", viewBox: "0 0 24 24" }],
    },
    {
        name: "heat-wiper",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-heat-wiper-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-heat-wiper", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "heat-yoke",
        metadata: { groups: ["vehicle"] },
        variants: [{ id: "icon-heat-yoke", viewBox: "0 0 24 24" }],
    },
    {
        name: "help",
        metadata: { aliases: ["question mark", "other"] },
        variants: [
            { id: "icon-help-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-help", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "history",
        metadata: { aliases: ["back", "past", "reverse", "undo"] },
        variants: [
            { id: "icon-history-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-history", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "home",
        metadata: { groups: ["starterkit"], aliases: ["house"] },
        variants: [
            { id: "icon-home-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-home", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "home-disconnect",
        metadata: { aliases: ["go off grid"] },
        variants: [
            { id: "icon-home-disconnect-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-home-disconnect", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "homelink",
        metadata: { aliases: ["home", "house"] },
        variants: [
            { id: "icon-homelink-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-homelink", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "horn",
        metadata: { groups: ["vehicle"], aliases: ["honk", "trumpet"] },
        variants: [
            { id: "icon-horn-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-horn", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "inbox",
        metadata: { aliases: ["mailbox", "notifications"] },
        variants: [
            { id: "icon-inbox-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-inbox", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "info",
        metadata: { groups: ["common", "starterkit"], aliases: ["details"] },
        variants: [
            { id: "icon-info-filled", viewBox: "0 0 24 24", filled: true },
            {
                id: "icon-info-small-filled",
                viewBox: "0 0 16 16",
                small: true,
                filled: true,
            },
            { id: "icon-info-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-info", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "in-progress",
        metadata: { aliases: ["status", "partially-complete", "pending"] },
        variants: [
            { id: "icon-in-progress-filled", viewBox: "0 0 24 24", filled: true },
            {
                id: "icon-in-progress-small-filled",
                viewBox: "0 0 16 16",
                small: true,
                filled: true,
            },
            { id: "icon-in-progress-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-in-progress", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "intake-fresh",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-intake-fresh-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-intake-fresh", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "karaoke",
        metadata: { aliases: ["microphone", "sing"] },
        variants: [
            { id: "icon-karaoke-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-karaoke", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "keep-climate",
        metadata: { aliases: ["lock fan"], groups: ["vehicle"] },
        variants: [
            { id: "icon-keep-climate-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-keep-climate", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "language",
        metadata: { aliases: ["localize", "localization", "i18n", "translate"] },
        variants: [
            { id: "icon-language-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-language", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "leaf",
        metadata: { groups: ["vehicle"], aliases: ["eco"] },
        variants: [
            { id: "icon-leaf-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-leaf", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "lights",
        metadata: { aliases: ["lightbulb"] },
        variants: [
            { id: "icon-lights-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-lights", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "like",
        metadata: { aliases: ["thumbs up", "good", "approve"] },
        variants: [
            { id: "icon-like-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-like", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "line-chart",
        metadata: { aliases: ["graph", "data"] },
        variants: [
            { id: "icon-line-chart-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-line-chart", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "link",
        metadata: { groups: ["starterkit"], aliases: ["chain", "hyperlink"] },
        variants: [
            { id: "icon-link-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-link", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "list",
        metadata: { aliases: ["unordered"] },
        variants: [
            { id: "icon-list-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-list", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "list-alt",
        metadata: { aliases: ["list", "unordered"] },
        variants: [
            { id: "icon-list-alt-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-list-alt", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "list-ordered",
        metadata: { aliases: ["list-alt", "list"] },
        variants: [
            { id: "icon-list-ordered-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-list-ordered", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "loader",
        metadata: {
            groups: ["common", "starterkit"],
            aliases: ["spinner", "progress"],
        },
        variants: [{ id: "icon-loader", viewBox: "0 0 48 48" }],
    },
    {
        name: "lock",
        metadata: { groups: ["starterkit"], aliases: ["secure"] },
        variants: [
            { id: "icon-lock-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-lock", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "logo",
        metadata: {
            groups: ["common", "branding", "starterkit"],
            aliases: ["watermark", "wordmark"],
        },
        variants: [{ id: "icon-logo", viewBox: "0 0 160 160" }],
    },
    {
        name: "logo-wordmark",
        metadata: {
            groups: ["common", "branding", "starterkit"],
            aliases: ["watermark"],
        },
        variants: [{ id: "icon-logo-wordmark", viewBox: "0 0 342 35" }],
    },
    {
        name: "loot-box",
        metadata: { aliases: ["box", "crate"] },
        variants: [
            { id: "icon-loot-box-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-loot-box", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "lyrics",
        variants: [
            { id: "icon-lyrics-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-lyrics", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "mail",
        metadata: {
            groups: ["starterkit"],
            aliases: ["letter", "email", "compose"],
        },
        variants: [
            { id: "icon-mail-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-mail", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "manual",
        metadata: { aliases: ["book", "library"] },
        variants: [
            { id: "icon-manual-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-manual", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "map",
        metadata: {
            aliases: ["maps", "route", "explore", "location", "navigation"],
        },
        variants: [
            { id: "icon-map-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-map", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "menu",
        metadata: { groups: ["starterkit"], aliases: ["hamburger", "bars"] },
        variants: [
            { id: "icon-menu-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-menu", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "message",
        metadata: { groups: ["starterkit"], aliases: ["chat", "text"] },
        variants: [
            { id: "icon-message-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-message", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "microphone",
        metadata: { aliases: ["voice"] },
        variants: [
            { id: "icon-microphone-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-microphone", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "minus",
        metadata: {
            groups: ["starterkit"],
            aliases: ["subtract", "dash", "line", "math"],
        },
        variants: [
            { id: "icon-minus-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-minus-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-minus", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "minus-circle",
        metadata: {
            groups: ["starterkit"],
            aliases: ["subtract", "dash", "line", "math"],
        },
        variants: [
            { id: "icon-minus-circle-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-minus-circle", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "mirror",
        metadata: { aliases: ["rearview"], groups: ["vehicle"] },
        variants: [
            { id: "icon-mirror-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-mirror", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "moon",
        metadata: { aliases: ["lunar", "moon-knight", "night", "dark mode"] },
        variants: [
            { id: "icon-moon-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-moon", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "music",
        metadata: { aliases: ["note"] },
        variants: [
            { id: "icon-music-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-music", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "mute",
        metadata: { groups: ["common", "media"], aliases: ["volume", "silence"] },
        variants: [
            { id: "icon-mute-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-mute", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "navigate",
        metadata: { aliases: ["map", "arrow", "chevron", "star trek"] },
        variants: [
            { id: "icon-navigate-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-navigate", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "network",
        metadata: { aliases: ["diagram", "graph", "relationship", "connection"] },
        variants: [
            { id: "icon-network-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-network", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "next",
        metadata: { aliases: ["skip", "forward"], groups: ["media"] },
        variants: [
            { id: "icon-next-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-next", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "north",
        metadata: { aliases: ["compass", "direction"] },
        variants: [
            { id: "icon-north-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-north", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "not-started",
        metadata: { aliases: ["status"] },
        variants: [
            { id: "icon-not-started-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-not-started-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-not-started", viewBox: "0 0 24 24" },
        ],
    },
    {
        metadata: {
            aliases: ["ellipsis", "dots", "horizontal"],
            groups: ["starterkit"],
        },
        name: "overflow",
        variants: [
            { id: "icon-overflow-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-overflow-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-overflow", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "partially-complete",
        metadata: { aliases: ["status", "pending", "in-progress"] },
        variants: [
            {
                id: "icon-partially-complete-filled",
                viewBox: "0 0 24 24",
                filled: true,
            },
            {
                id: "icon-partially-complete-small",
                viewBox: "0 0 16 16",
                small: true,
            },
            { id: "icon-partially-complete", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "passport",
        variants: [
            { id: "icon-passport-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-passport", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "pause",
        metadata: { groups: ["common", "media", "starterkit"] },
        variants: [
            { id: "icon-pause-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-pause", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "pause-circle",
        metadata: { aliases: ["stop"], groups: ["media"] },
        variants: [
            { id: "icon-pause-circle-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-pause-circle", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "payment",
        metadata: { aliases: ["credit card", "money"] },
        variants: [
            { id: "icon-payment-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-payment", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "pdf",
        metadata: {
            aliases: ["document", "adobe acrobat"],
            groups: ["starterkit"],
        },
        variants: [
            { id: "icon-pdf-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-pdf", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "pencil",
        metadata: { groups: ["starterkit"], aliases: ["new", "edit", "create"] },
        variants: [
            { id: "icon-pencil-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-pencil", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "pending",
        metadata: { aliases: ["status", "partially-complete", "in-progress"] },
        variants: [
            { id: "icon-pending-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-pending-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-pending", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "performance",
        metadata: { aliases: ["dial", "meter", "gauge"], groups: ["native"] },
        variants: [
            { id: "icon-performance-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-performance", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "person",
        metadata: {
            groups: ["starterkit"],
            aliases: ["avatar", "contacts", "user"],
        },
        variants: [
            { id: "icon-person-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-person", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "phone",
        metadata: { groups: ["starterkit"], aliases: ["call", "chat", "talk"] },
        variants: [
            { id: "icon-phone-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-phone", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "phone-key",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-phone-key-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-phone-key", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "photo",
        metadata: { groups: ["starterkit"], aliases: ["picture", "frame"] },
        variants: [
            { id: "icon-photo-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-photo", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "pin",
        metadata: {
            groups: ["starterkit"],
            aliases: ["map", "location", "destination"],
        },
        variants: [
            { id: "icon-pin-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-pin", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "placeholder",
        metadata: {
            aliases: ["dummy", "crash-test-dummy", "tbd", "incoming", "test"],
        },
        variants: [
            { id: "icon-placeholder-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-placeholder", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "play",
        metadata: { groups: ["starterkit"], aliases: ["go", "start"] },
        variants: [
            { id: "icon-play-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-play", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "play-circle",
        metadata: {
            groups: ["common", "media", "native"],
            aliases: ["go", "start"],
        },
        variants: [
            { id: "icon-play-circle-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-play-circle", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "playing",
        metadata: { aliases: ["now playing"] },
        variants: [
            { id: "icon-playing-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-playing", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "plus",
        metadata: { groups: ["starterkit"], aliases: ["add", "math"] },
        variants: [
            { id: "icon-plus-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-plus-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-plus", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "plus-circle",
        metadata: { groups: ["starterkit"], aliases: ["add", "math"] },
        variants: [
            { id: "icon-plus-circle-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-plus-circle", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "popout",
        metadata: { aliases: ["expand", "open"] },
        variants: [
            { id: "icon-popout-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-popout", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "power",
        metadata: { aliases: ["enable", "i/o", "on/off"] },
        variants: [
            { id: "icon-power-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-power", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "powerwall",
        metadata: { aliases: ["product", "energy"] },
        variants: [
            { id: "icon-powerwall-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-powerwall", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "previous",
        metadata: { aliases: ["skip back"], groups: ["media"] },
        variants: [
            { id: "icon-previous-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-previous", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "printer",
        metadata: { groups: ["starterkit"] },
        variants: [
            { id: "icon-printer-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-printer", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "radio",
        metadata: { aliases: ["signal"] },
        variants: [
            { id: "icon-radio-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-radio", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "raise-suspension",
        metadata: { groups: ["vehicle"] },
        variants: [{ id: "icon-raise-suspension", viewBox: "0 0 24 24" }],
    },
    {
        name: "recents",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-recents-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-recents", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "recirculation",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-recirculation-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-recirculation", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "recirculation-open",
        metadata: { groups: ["vehicle"] },
        variants: [
            {
                id: "icon-recirculation-open-filled",
                viewBox: "0 0 24 24",
                filled: true,
            },
            { id: "icon-recirculation-open", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "recurring",
        metadata: { groups: ["starterkit"], aliases: ["repeating"] },
        variants: [
            { id: "icon-recurring-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-recurring", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "reload",
        metadata: { aliases: ["refresh", "restart"], groups: ["starterkit"] },
        variants: [
            { id: "icon-reload-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-reload", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "remote",
        metadata: { groups: ["vehicle"], aliases: ["fob", "control"] },
        variants: [
            { id: "icon-remote-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-remote", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "repeat",
        metadata: { aliases: ["loop"], groups: ["media"] },
        variants: [
            { id: "icon-repeat-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-repeat", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "resources",
        metadata: { aliases: ["book"], groups: ["native"] },
        variants: [
            { id: "icon-resources-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-resources", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "restaurant",
        metadata: { aliases: ["food", "fork", "knife"] },
        variants: [
            { id: "icon-restaurant-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-restaurant", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "restroom",
        metadata: { aliases: ["bathroom"] },
        variants: [
            { id: "icon-restroom-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-restroom", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "rewind",
        metadata: { aliases: ["skip back"], groups: ["media"] },
        variants: [
            { id: "icon-rewind-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-rewind", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "robot",
        metadata: { aliases: ["ai", "optimus"] },
        variants: [
            { id: "icon-robot-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-robot", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "rocket",
        metadata: { aliases: ["launch", "space"], groups: ["vehicle"] },
        variants: [
            { id: "icon-rocket-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-rocket", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "route-overview",
        metadata: { aliases: ["trip"], groups: ["vehicle"] },
        variants: [
            { id: "icon-route-overview-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-route-overview", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "rows",
        metadata: {
            aliases: ["list", "layout", "grid", "filter", "columns", "row", "table"],
        },
        variants: [
            { id: "icon-rows-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-rows", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "safety-rating",
        metadata: { groups: ["vehicle"], aliases: ["speedometer"] },
        variants: [
            { id: "icon-safety-rating-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-safety-rating", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "scan",
        metadata: { aliases: ["barcode"] },
        variants: [
            { id: "icon-scan-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-scan", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "schedule",
        metadata: { aliases: ["alarm", "timer"] },
        variants: [
            { id: "icon-schedule-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-schedule", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "screenshot",
        metadata: { aliases: ["screencap"] },
        variants: [
            { id: "icon-screenshot-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-screenshot", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "search",
        metadata: { aliases: ["magnify", "find"] },
        variants: [
            { id: "icon-search-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-search", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "seat",
        metadata: { groups: ["vehicle"] },
        variants: [{ id: "icon-seat", viewBox: "0 0 24 24" }],
    },
    {
        name: "seat-heat",
        metadata: { groups: ["vehicle"] },
        variants: [{ id: "icon-seat-heat", viewBox: "0 0 24 24" }],
    },
    {
        name: "seat-heat-passenger",
        metadata: { groups: ["vehicle"] },
        variants: [{ id: "icon-seat-heat-passenger", viewBox: "0 0 24 24" }],
    },
    {
        name: "security",
        metadata: { aliases: ["shield", "secure"] },
        variants: [
            { id: "icon-security-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-security", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "send",
        metadata: { aliases: ["airplane", "paper airplane", "post"] },
        variants: [
            { id: "icon-send-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-send", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "service",
        metadata: { aliases: ["wrench", "maintenance"] },
        variants: [
            { id: "icon-service-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-service", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "settings-alt",
        metadata: { aliases: ["configure", "filters"] },
        variants: [
            { id: "icon-settings-alt-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-settings-alt", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "share",
        metadata: { groups: ["common"], aliases: ["arrow"] },
        variants: [
            { id: "icon-share-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-share", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "shield",
        metadata: { groups: [], aliases: ["insurance"] },
        variants: [
            { id: "icon-shield-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-shield", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "shirt",
        metadata: { aliases: ["t-shirt", "apparel", "clothes"] },
        variants: [
            { id: "icon-shirt-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-shirt", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "shuffle",
        metadata: { groups: ["media"] },
        variants: [
            { id: "icon-shuffle-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-shuffle", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "sign-out",
        metadata: { groups: ["common"], aliases: ["arrow", "exit"] },
        variants: [
            { id: "icon-sign-out-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-sign-out", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "smartphone",
        metadata: { groups: ["starterkit"], aliases: ["device", "call"] },
        variants: [
            { id: "icon-smartphone-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-smartphone", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "solar-panel",
        metadata: { aliases: ["sun", "energy"] },
        variants: [
            { id: "icon-solar-panel-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-solar-panel", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "solar-roof",
        metadata: { aliases: ["sun", "energy"] },
        variants: [
            { id: "icon-solar-roof-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-solar-roof", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "speaker",
        metadata: {
            groups: ["common", "media", "starterkit"],
            aliases: ["volume"],
        },
        variants: [
            {
                id: "icon-speaker-filled-high",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "high",
            },
            {
                id: "icon-speaker-filled-low",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "low",
            },
            {
                id: "icon-speaker-filled-mute",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "mute",
            },
            { id: "icon-speaker-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-speaker-high", viewBox: "0 0 24 24", variant: "high" },
            { id: "icon-speaker-low", viewBox: "0 0 24 24", variant: "low" },
            { id: "icon-speaker-mute", viewBox: "0 0 24 24", variant: "mute" },
            { id: "icon-speaker", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "speedometer",
        metadata: { aliases: ["safety-score"] },
        variants: [
            { id: "icon-speedometer-filled", viewBox: "0 0 24 24", filled: true },
        ],
    },
    {
        name: "star",
        metadata: { aliases: ["favorite", "like", "vip"], groups: ["starterkit"] },
        variants: [
            { id: "icon-star-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-star", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "status-error",
        metadata: { groups: ["common", "starterkit"], aliases: ["warning"] },
        variants: [
            { id: "icon-status-error-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-status-error", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "status-info",
        metadata: { groups: ["common", "starterkit"] },
        variants: [
            { id: "icon-status-info-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-status-info", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "status-success",
        metadata: {
            groups: ["common", "starterkit"],
            aliases: ["approved", "check"],
        },
        variants: [
            { id: "icon-status-success-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-status-success", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "status-warning",
        metadata: { groups: ["common", "starterkit"], aliases: ["error"] },
        variants: [
            { id: "icon-status-warning-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-status-warning", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "steering-wheel",
        metadata: { aliases: [] },
        variants: [
            { id: "icon-steering-wheel-yoke", viewBox: "0 0 24 24", variant: "yoke" },
            { id: "icon-steering-wheel", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "stop",
        metadata: { groups: ["media"] },
        variants: [
            { id: "icon-stop-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-stop", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "stop-circle",
        metadata: { groups: ["media"] },
        variants: [
            { id: "icon-stop-circle-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-stop-circle", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "storm",
        metadata: {
            aliases: [
                "storm watch",
                "thunder",
                "thunderstorm",
                "lightning",
                "weather",
            ],
        },
        variants: [
            { id: "icon-storm-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-storm", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "streaming",
        metadata: { aliases: ["rss", "feed"] },
        variants: [
            { id: "icon-streaming-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-streaming", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "success",
        metadata: {
            groups: ["common", "starterkit"],
            aliases: ["approved", "check", "status"],
        },
        variants: [
            { id: "icon-success-filled", viewBox: "0 0 24 24", filled: true },
            {
                id: "icon-success-small-filled",
                viewBox: "0 0 16 16",
                small: true,
                filled: true,
            },
            { id: "icon-success-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-success", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "sun",
        metadata: { aliases: ["brightness", "heat", "light mode", "solar", "day"] },
        variants: [
            { id: "icon-sun-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-sun", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "suspension",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-suspension-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-suspension", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "temperature",
        metadata: { aliases: ["thermometer"] },
        variants: [
            { id: "icon-temperature-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-temperature", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "terminal",
        metadata: { aliases: ["code", "console", "command line", "programming"] },
        variants: [
            { id: "icon-terminal-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-terminal", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "test",
        metadata: { aliases: ["beaker", "flask", "experiment", "science"] },
        variants: [
            { id: "icon-test-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-test", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "wheel",
        metadata: { aliases: ["tire"] },
        variants: [
            { id: "icon-wheel-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-wheel", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "toybox",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-toybox-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-toybox", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "traffic",
        metadata: { aliases: ["stoplight"], groups: ["vehicle"] },
        variants: [
            { id: "icon-traffic-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-traffic", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "trailer",
        variants: [
            { id: "icon-trailer-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-trailer", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "transfer",
        metadata: { aliases: ["exchange", "change", "transaction"] },
        variants: [
            { id: "icon-transfer-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-transfer", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "trash",
        metadata: { groups: ["starterkit"], aliases: ["delete", "remove"] },
        variants: [
            { id: "icon-trash-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-trash", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "trip",
        metadata: { aliases: ["route"] },
        variants: [
            { id: "icon-trip-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-trip", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "trunk",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-trunk-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-trunk", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "unlock",
        metadata: { groups: ["vehicle"], aliases: ["lock"] },
        variants: [
            { id: "icon-unlock-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-unlock", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "upload",
        metadata: { groups: ["starterkit"], aliases: ["arrow", "check"] },
        variants: [
            { id: "icon-upload-filled", viewBox: "0 0 24 24", filled: true },
            {
                id: "icon-upload-small-filled",
                viewBox: "0 0 16 16",
                small: true,
                filled: true,
            },
            { id: "icon-upload-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-upload", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "usb",
        variants: [
            { id: "icon-usb-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-usb", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "user",
        metadata: {
            groups: ["starterkit"],
            aliases: ["avatar", "contacts", "person"],
        },
        variants: [
            { id: "icon-user-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-user", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "user-cloud",
        metadata: { aliases: ["profile cloud"], groups: ["vehicle"] },
        variants: [
            { id: "icon-user-cloud-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-user-cloud", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "valet",
        metadata: { aliases: ["bowtie"], groups: ["vehicle"] },
        variants: [{ id: "icon-valet", viewBox: "0 0 24 24" }],
    },
    {
        name: "vehicle",
        metadata: {
            groups: ["common", "vehicle"],
            aliases: [
                "car",
                "truck",
                "product",
                "model 3",
                "m3",
                "model y",
                "my",
                "model s",
                "ms",
                "model x",
                "mx",
                "cybertruck",
            ],
        },
        variants: [
            {
                id: "icon-vehicle-cybertruck-filled",
                viewBox: "0 0 24 24",
                variant: "cybertruck",
                filled: true,
            },
            {
                id: "icon-vehicle-cybertruck",
                viewBox: "0 0 24 24",
                variant: "cybertruck",
            },
            {
                id: "icon-vehicle-model-3y-filled",
                viewBox: "0 0 24 24",
                variant: "model-3y",
                filled: true,
            },
            {
                id: "icon-vehicle-model-3y",
                viewBox: "0 0 24 24",
                variant: "model-3y",
            },
            {
                id: "icon-vehicle-model-s-filled",
                viewBox: "0 0 24 24",
                variant: "model-s",
                filled: true,
            },
            { id: "icon-vehicle-model-s", viewBox: "0 0 24 24", variant: "model-s" },
            {
                id: "icon-vehicle-model-x-filled",
                viewBox: "0 0 24 24",
                variant: "model-x",
                filled: true,
            },
            { id: "icon-vehicle-model-x", viewBox: "0 0 24 24", variant: "model-x" },
            {
                id: "icon-vehicle-semi-filled",
                viewBox: "0 0 24 24",
                variant: "semi",
                filled: true,
            },
            { id: "icon-vehicle-semi", viewBox: "0 0 24 24", variant: "semi" },
            { id: "icon-vehicle", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "vent-windows",
        metadata: { groups: ["vehicle"], aliases: ["windows"] },
        variants: [
            { id: "icon-vent-windows-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-vent-windows", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "video",
        metadata: { aliases: ["camera"] },
        variants: [
            { id: "icon-video-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-video", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "wall-charger",
        metadata: { aliases: ["product", "plug"], groups: ["vehicle"] },
        variants: [
            { id: "icon-wall-charger-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-wall-charger", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "warning",
        metadata: {
            groups: ["common", "starterkit"],
            aliases: ["error", "status"],
        },
        variants: [
            { id: "icon-warning-filled", viewBox: "0 0 24 24", filled: true },
            {
                id: "icon-warning-small-filled",
                viewBox: "0 0 16 16",
                small: true,
                filled: true,
            },
            { id: "icon-warning-small", viewBox: "0 0 16 16", small: true },
            { id: "icon-warning", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "wifi",
        metadata: { aliases: ["connection", "signal"] },
        variants: [
            { id: "icon-wifi-0", viewBox: "0 0 24 24", variant: "0" },
            { id: "icon-wifi-1", viewBox: "0 0 24 24", variant: "1" },
            { id: "icon-wifi-2", viewBox: "0 0 24 24", variant: "2" },
            { id: "icon-wifi-3", viewBox: "0 0 24 24", variant: "3" },
            {
                id: "icon-wifi-filled-0",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "0",
            },
            {
                id: "icon-wifi-filled-1",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "1",
            },
            {
                id: "icon-wifi-filled-2",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "2",
            },
            {
                id: "icon-wifi-filled-3",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "3",
            },
            {
                id: "icon-wifi-filled-none",
                viewBox: "0 0 24 24",
                filled: true,
                variant: "none",
            },
            { id: "icon-wifi-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-wifi-none", viewBox: "0 0 24 24", variant: "none" },
            { id: "icon-wifi", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "window-lock",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-window-lock-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-window-lock", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "wiper",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-wiper-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-wiper", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "wiper-wash",
        metadata: { groups: ["vehicle"] },
        variants: [
            { id: "icon-wiper-wash-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-wiper-wash", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "work",
        metadata: { aliases: ["briefcase", "job", "company"] },
        variants: [
            { id: "icon-work-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-work", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "x-circle",
        metadata: { aliases: ["close", "cancel"], groups: ["starterkit"] },
        variants: [
            { id: "icon-x-circle-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-x-circle", viewBox: "0 0 24 24" },
        ],
    },
    {
        name: "zip",
        metadata: { aliases: ["document", "archive"], groups: ["starterkit"] },
        variants: [
            { id: "icon-zip-filled", viewBox: "0 0 24 24", filled: true },
            { id: "icon-zip", viewBox: "0 0 24 24" },
        ],
    },
];
